import { useEffect } from 'react'
import Head from 'next/head'
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles'
import { CacheProvider } from '@emotion/react'
import CssBaseline from '@mui/material/CssBaseline'

import theme from 'config/theme'
import { LS_APP_DOMAIN, FB_TRACKING_APP_ID } from 'config/constants'
import { createEmotionCache } from 'utils/styles/emotion'
import LandingFallback from 'components/common/LandingFallback'

const clientSideEmotionCache = createEmotionCache()

function MyApp({
  Component,
  emotionCache = clientSideEmotionCache,
  pageProps,
}) {
  const title = '設計裝潢、搬家清運、清潔除蟲、家居設備、局部修繕就找信義居家'
  const description =
    '裝潢設計、修繕工程、搬家清運、居家清潔服務，家裡的大小事，都讓居家幫你搞定，信義房屋住家生活服務平台。'

  return (
    <>
      <CacheProvider value={emotionCache}>
        <Head>
          <title>{title}</title>

          <link key="canonical" rel="canonical" href={`${LS_APP_DOMAIN}`} />
          <link
            rel="apple-touch-icon"
            href={`${LS_APP_DOMAIN}/img/iPhone_App_60_3x.png`}
          />

          {/* 
          Add noindex to all pages except the login page and service intro pages.
          Those pages which don't need the noindex should contain NoindexRemoval component.
        */}
          <meta key="noindex" name="robots" content="noindex" />

          <meta
            name="viewport"
            content="minimum-scale=1, initial-scale=1, width=device-width"
          />

          {/* Begin for Google */}
          <meta
            key="google-adsense-account"
            name="google-adsense-account"
            content="ca-pub-7532513636591043"
          />
          <meta key="title" name="title" content={title} />
          <meta key="description" name="description" content={description} />
          <meta key="author" name="author" content="信義居家" />
          <meta
            key="copyright"
            name="copyright"
            content="本網頁著作權屬信義房屋股份有限公司, All Rights Reserved"
          />
          <meta
            key="application-name"
            name="application-name"
            content="信義居家好生活"
          />
          {/* End for Google */}

          {/* Begin for Facebook */}
          <meta key="og:type" property="og:type" content="website" />
          <meta
            key="fb:app_id"
            property="fb:app_id"
            content={FB_TRACKING_APP_ID}
          />
          <meta key="og:title" property="og:title" content={title} />
          <meta
            key="og:description"
            property="og:description"
            content={description}
          />
          <meta key="og:url" property="og:url" content={`${LS_APP_DOMAIN}`} />
          <meta key="og:site_name" property="og:site_name" content="信義居家" />
          {/* End for Facebook */}
        </Head>
        <MuiThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          {/* 廣告到達頁降級：資料取得失敗時於原網址回 200 呈現此畫面（見 withSafeServerSideProps），
              刻意繞過各頁的 withLivingSinyi，確保降級畫面不依賴任何可能失敗的 provider */}
          {pageProps?.__landingFallback ? (
            <LandingFallback />
          ) : (
            <Component {...pageProps} />
          )}
        </MuiThemeProvider>
      </CacheProvider>
    </>
  )
}

export default MyApp
